import React, { useEffect, useState } from 'react'

import LogoAccent from '../../assets/NewDesign/logo-accent.svg'
import { LANDING_ACCENT_BG_CLASS, LANDING_ACCENT_HOVER_BG_CLASS } from '../Page2026/landingSectionStyles'

export default function Header() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || document.documentElement.scrollTop
      setScrolled(y > 0)
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={[
        'fixed left-0 right-0 top-0 z-40 w-full transition-[background-color,border-color,backdrop-filter] duration-300 ease-out',
        scrolled
          ? 'bg-[rgba(255,255,255,0.5)] backdrop-blur'
          : 'bg-transparent backdrop-blur-none',
      ].join(' ')}
    >
      <div className="mx-auto flex h-[92px] w-full items-center justify-between px-[80px] mobile:px-[16px]">
        <a
          href="/"
          className="inline-flex h-[38px] w-[270px] shrink-0 items-center gap-[10px] overflow-hidden"
          aria-label="Дисенс — Анализатор AmoCRM и Битрикс24"
        >
          <img
            src={LogoAccent}
            alt=""
            className="h-[32px] w-[32px] shrink-0 object-contain"
            width={32}
            height={32}
          />
          <span className="flex min-h-0 min-w-0 flex-1 flex-col justify-center gap-px leading-none">
            <span className="select-none truncate text-[16px] font-bold tracking-[-0.5px] text-[#1A202C] mb-[3px]">
              Дисенс
            </span>
            <span className="select-none truncate text-[12px] font-normal tracking-[-0.35px] text-[#1A202CB3]">
              Анализатор AmoCRM и Битрикс24
            </span>
          </span>
        </a>

        <nav className="flex items-center gap-8 mobile:gap-3">
          <a
            href="https://app.disens.ru/login"
            className="text-[16px] font-medium leading-none tracking-[-0.5px] text-[#1A202CCC] transition-colors hover:text-[#1A202C] whitespace-nowrap mobile:hidden"
          >
            Вход
          </a>
          <a
            href="https://app.disens.ru/register"
            className={`flex h-[44px] min-h-[44px] items-center justify-center rounded-[22px] px-6 text-[16px] font-medium leading-none tracking-[-0.5px] text-white transition-colors whitespace-nowrap ${LANDING_ACCENT_BG_CLASS} ${LANDING_ACCENT_HOVER_BG_CLASS}`}
          >
            Регистрация
          </a>
        </nav>
      </div>
    </header>
  )
}
